import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { buscarContaRecorrenteModel } from "../models/contaRecorrente/buscarContaRecorrenteModel";
import { GerarRecorrenciaModel } from "../models/contaRecorrente/gerarRecorrenciaModel";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setPageContaRecorrente } from "../redux/slices/contaRecorrente/contaRecorrenteSlice";

export const cadastrarContaRecorrente = createAsyncThunk("/ContaRecorrente/CadastrarContaRecorrente", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/ContaRecorrente/CadastrarContaRecorrente", payload.value);
    toastSucess("Conta recorrente cadastrado com sucesso");
    dispatch(setPageContaRecorrente("geral"));
    dispatch(setLoading(false));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarContaRecorrente = createAsyncThunk("/ContaRecorrente/BuscarContaRecorrente", async (args: buscarContaRecorrenteModel) => {
  try {
    const data = await api.get("/ContaRecorrente/BuscarContaRecorrente", {
      params: args,
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const gerarRecorrencia = createAsyncThunk("/ContaRecorrente/GerarRecorrencia", async (args: GerarRecorrenciaModel) => {
  try {
    const data = await api.get("/ContaRecorrente/GerarRecorrencia", {
      params: args,
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const buscarDetalheContaRecorrente = createAsyncThunk("/ContaRecorrente/BuscarDetalheContaRecorrente", async (idContaFinanceira: number) => {
  try {
    const data = await api.get("/ContaRecorrente/BuscarDetalheContaRecorrente", {
      params: { idContaFinanceira: idContaFinanceira },
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const buscarDetalheRateioContaRecorrente = createAsyncThunk("/ContaRecorrente/BuscarDetalheRateioContaRecorrente", async (idContaFinanceira: number) => {
  try {
    const data = await api.get("/ContaRecorrente/BuscarDetalheRateioContaRecorrente", {
      params: { idContaFinanceira: idContaFinanceira },
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const listarContaRecorrenteAtivos = createAsyncThunk("/ContaRecorrente/ListarContaRecorrenteAtivos", async () => {
  try {
    const data = await api.get("/ContaRecorrente/ListarContaRecorrenteAtivos");
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarContaRecorrente = createAsyncThunk("/ContaRecorrente/AtualizarContaRecorrente", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/ContaRecorrente/AtualizarContaRecorrente", payload.value);
    toastSucess("Conta recorrente atualizada com sucesso");
    dispatch(setPageContaRecorrente("geral"));
    dispatch(setLoading(false));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarContaRecorrente = createAsyncThunk("/ContaRecorrente/DeletarContaRecorrente", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/ContaRecorrente/DeletarContaRecorrente", {
      params: { id: payload.value },
    });
    toastSucess("Conta recorrente removida com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarContaRecorrente(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
